import { useCurrency, walletSettings } from '@bz/common';
import Decimal from 'decimal.js-light';

const useNegativeEquity = () => {
  const { latestCurrency } = useCurrency();
  // 检查是否有任何一种货币的余额小于0
  const isNegative = createMemo(() => {
    const currencyMap = currencyRecommend.currencyMap;
    return Object.values(currencyMap).some((item) => Number(item?.balance) < 0);
  });

  const isNegativeCurrent = createMemo(() => {
    const balance = Number(currencyRecommend.currencyMap[latestCurrency()]?.['balance']);
    return balance < 0;
  });
  const balance = createMemo(() => {
    return currencyRecommend.currencyMap[latestCurrency()]?.['balance'] ?? 0;
  });

  const showCurrency = createMemo(() => {
    return walletSettings.showCurrency;
  });
  // 转换的余额
  const convertedBalance = createMemo(() => {
    return currency.convertCurrency(new Decimal(Math.abs(balance())), latestCurrency(), showCurrency()).toString();
  });

  const isCash = createMemo(() => {
    return currencyRecommend.currencyMap[latestCurrency()]?.['type'] === 'FIAT';
  });

  const allNegativeCurrency = createMemo(() => {
    const currencyMap = currencyRecommend.currencyMap;
    return Object.values(currencyMap).filter((item) => Number(item?.balance) < 0);
  });

  const allNegativeFIATCurrency = createMemo(() => {
    return allNegativeCurrency().filter((item) => item.type === 'FIAT');
  });
  const allNegativeCryptoCurrency = createMemo(() => {
    return allNegativeCurrency().filter((item) => item.type === 'CRYPTO');
  });

  // 获取负资产跳转链接，优先法币
  const getNegativeDepositUrl = () => {
    const negatives = allNegativeCurrency();
    if (negatives.length === 0) {
      return '/deposit';
    }
    // 优先找法币
    const fiatNegative = negatives.find((item) => item.type === 'FIAT');
    if (fiatNegative) {
      return `/deposit?tab=cash&negativeCurrencyCode=${fiatNegative.currencyCode}`;
    }
    // 否则使用第一个虚拟货币
    const cryptoNegative = negatives[0];
    return `/deposit?tab=crypto&negativeCurrencyCode=${cryptoNegative.currencyCode}`;
  };

  return {
    isNegative,
    balance,
    latestCurrency,
    showCurrency,
    convertedBalance,
    isCash,
    allNegativeCurrency,
    getNegativeDepositUrl,
    isNegativeCurrent,
    allNegativeFIATCurrency,
    allNegativeCryptoCurrency,
  };
};
export default useNegativeEquity;
